module.exports = __webpack_public_path__ + "img/riyu.b1b9b00b.png";